module.exports = __webpack_public_path__ + "img/atras.63a59e4b.svg";